import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { AllFlags } from '@growthBookExperimentation/Entities/FlagKeys.entities';

import { LeadType } from './LeadCTAs.entity';
import { LeadCtaConfig, LeadCtaConfigArray } from './LeadCtaConfig';

const ctasToIgnore: Array<LeadType> = [
  'request-video',
  'request-images',
  'call-dealer',
  'book-appointment',
  'history-check',
  'leasing-online',
];
const REQUEST_CB_ID = 'requestCallbackButton';

export const getLeadCtasForDisplay = (
  orderedLeadCtasConfig: LeadCtaConfig,
  flags: AllFlags | undefined,
  isEcom: boolean,
  vehicle: Vehicle,
): LeadCtaConfigArray =>
  Object.entries(orderedLeadCtasConfig)
    .filter(([id, data]) => {
      return data.isActive({ flags, isEcom, vehicle }) && !ctasToIgnore.includes(id as LeadType);
    })
    .map(([id, data]) => [id as LeadType, data]);

export const getNumOfCTAs = (
  leadCtasToDisplay: LeadCtaConfigArray,
  isReservedOrInactive: boolean,
  isEcom: boolean,
  isReserveNow: boolean,
): number => {
  const defaultCtas = 1; //call dealer
  if (isReservedOrInactive) return 1;

  let numOfCTAs =
    defaultCtas +
    leadCtasToDisplay.filter(cta => {
      // Dont need to count request CB as we have counted call dealer
      // and one or the other is always shown
      return cta[1].labelId() !== REQUEST_CB_ID;
    }).length;

  if (isEcom) numOfCTAs += 1; //buy online
  if (isReserveNow) numOfCTAs += 1; //reserve now

  return numOfCTAs;
};
